import { z } from 'zod';

import { UserStatus } from '../../constants';

function addValidationIssue(ctx: z.RefinementCtx, path: (string | number)[], message: string) {
  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    path,
    message,
  });
}

export const UserDetailsFormSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, { message: 'กรุณากรอกชื่อ' })
    .regex(/^[a-zA-Z\s()]*$/, { message: 'กรุณากรอกชื่อภาษาอังกฤษ' }),
  lastName: z
    .string()
    .trim()
    .min(1, { message: 'กรุณากรอกนามสกุล' })
    .regex(/^[a-zA-Z\s()]*$/, { message: 'กรุณากรอกนามสกุลภาษาอังกฤษ' }),
  email: z
    .string()
    .trim()
    .email({ message: 'กรุณากรอก Email ให้ถูกต้อง' })
    .regex(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, { message: 'กรุณากรอก Email ให้ถูกต้อง' }),
  activated: z.enum(['true', 'false']).optional(),
  appRoles: z
    .array(
      z.object({
        label: z.string(),
        value: z.string(),
      }),
    )
    .optional(),
});

export function getUserDetailsFormSchema(
  isOwner: boolean,
  status: UserStatus | undefined,
  hasEditStatusPermission: boolean,
) {
  const isActivatedOptional =
    isOwner ||
    !hasEditStatusPermission ||
    status === UserStatus.INVITATION_EXPIRED ||
    status === UserStatus.INVITATION_PENDING;

  return UserDetailsFormSchema.superRefine((data, ctx) => {
    if (!isActivatedOptional && data.activated === undefined) {
      addValidationIssue(ctx, ['activated'], 'กรุณากรอกสถานะผู้ใช้');
    }
  });
}
